const QUESTION_TYPE = {
    READING: 'READING',
    LISTENING: 'LISTENING',
    WRITING: 'WRITING',
}
export default QUESTION_TYPE;